import React from "react";
import { ListFilter } from "lucide-react";
import "../pages/adminPages.css";

const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  txt1: "#0f172a", txt2: "#475569",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

const Checkbox = ({
    infoSource,
    handleToggle,
    checkSel,
    filter,
    catID,
    token
}) => (
    <div className="admin-card" style={{ overflow: "hidden", fontFamily: D.font }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "12px 16px", borderBottom: `1px solid ${D.border}` }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 26, height: 26, borderRadius: 8, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
                <ListFilter size={14} />
            </span>
            <h3 style={{ fontSize: 13, fontWeight: 700, color: D.txt2, margin: 0 }}>
                {infoSource.laguangeElakay('title', infoSource.languageAPI).filterelakay} {filter.name}
            </h3>
        </div>
        <div style={{ maxHeight: 460, overflowY: "auto" }}>
            {filter.FilterItem && filter.FilterItem?.map((c, i) => {
                const checked = checkSel(c) ? true : false;
                return (
                    <label
                        key={i}
                        htmlFor={filter._id + "_" + c}
                        style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 16px", borderBottom: `1px solid ${D.border}`, cursor: "pointer", background: checked ? D.bg : "#fff" }}
                    >
                        <input
                            onChange={handleToggle(catID, filter._id, c, token)}
                            value={c}
                            checked={checked}
                            type="checkbox"
                            id={filter._id + "_" + c}
                            style={{ width: 16, height: 16, cursor: "pointer", flexShrink: 0 }}
                        />
                        <span style={{ fontSize: 13, color: D.txt1, fontWeight: checked ? 600 : 400 }}>
                            {c}
                        </span>
                    </label>
                );
            })}
        </div>
    </div>
);

export default Checkbox;
